export default __webpack_public_path__ + "static/media/biote_fin.e713e481.png";